module.exports = __webpack_public_path__ + "static/img/n-one.4105fd64.webp";